<section
  class="flex flex-col items-center justify-between space-y-6 text-center text-slate-900 p-8 tablet-sm:p-20 w-fit mx-auto"
  role="status"
  aria-live="polite"
  *transloco="let t; scope: scope; read: scope"
>
  <!-- Loading spinner -->
  <div class="relative h-32 w-32 flex items-center justify-center">
    <div
      class="h-16 w-16 animate-spin rounded-full border-4 border-slate-200 border-t-viking_red"
      aria-hidden="true"
    ></div>
  </div>

  <div class="flex flex-col items-center gap-4 justify-center">
    <div class="space-y-4 pt-10 pb-20">
      <p class="text-2xl font-averta-semibold uppercase">{{ t("loading.title") }}</p>
      <p class="text-base font-calibre-regular text-font_grey_primary max-w-md">
        {{ t("loading.message") }}
      </p>
    </div>
  </div>
</section>
